import { render, staticRenderFns } from "./HighwayInput3.vue?vue&type=template&id=54e5bbbd"
import script from "./HighwayInput3.vue?vue&type=script&lang=js"
export * from "./HighwayInput3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports